/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilelinkfailed2Inputs */

const en_profilelinkfailed2 = /** @type {(inputs: Profilelinkfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecting did not work`)
};

const de_profilelinkfailed2 = /** @type {(inputs: Profilelinkfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbinden hat nicht geklappt`)
};

/**
* | output |
* | --- |
* | "Connecting did not work" |
*
* @param {Profilelinkfailed2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilelinkfailed2 = /** @type {((inputs?: Profilelinkfailed2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilelinkfailed2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilelinkfailed2(inputs)
	return de_profilelinkfailed2(inputs)
});
export { profilelinkfailed2 as "profileLinkFailed" }